
/**
 * Custom Slideshow Progress Ring and Controls
 */
if (!customElements.get('slideshow-component-custom')) {
  class SlideshowProgress {
    constructor(slideshow) {
      this.slideshow = slideshow;
      this.autoplayButton = slideshow.querySelector('.slideshow__autoplay');
      if (!this.autoplayButton) return;

      this.circle = this.autoplayButton.querySelector('.progress-ring__circle');
      if (!this.circle) return;

      this.init();
    }

    init() {
      const radius = this.circle.r.baseVal.value;
      this.circumference = radius * 2 * Math.PI;
      this.circle.style.strokeDasharray = `${this.circumference} ${this.circumference}`;
      this.circle.style.strokeDashoffset = this.circumference;
      this.circle.style.transition = 'none';

      this.duration = parseInt(this.slideshow.querySelector('.slideshow').dataset.speed) * 1000;
      this.currentTime = 0;
      this.lastTimestamp = null;
      
      // Capture the original pause to clear the built-in interval
      const originalPause = this.slideshow.pause.bind(this.slideshow);
      originalPause();
      
      // Override play/pause to prevent hover/focus interruptions from global.js
      this.slideshow.play = () => {
        this.slideshow.slider.setAttribute('aria-live', 'off');
      };
      this.slideshow.pause = () => {
        this.slideshow.slider.setAttribute('aria-live', 'polite');
      };

      this.patchMethods();
      requestAnimationFrame(this.animate.bind(this));
    }

    patchMethods() {
      const self = this;
      const ss = this.slideshow;

      const resetTimer = () => {
        self.currentTime = 0;
      };

      // Add direct event listeners to ensure reset regardless of bound functions in global.js
      const prevBtn = ss.querySelector('button[name="previous"]');
      const nextBtn = ss.querySelector('button[name="next"]');
      if (prevBtn) prevBtn.addEventListener('click', resetTimer);
      if (nextBtn) nextBtn.addEventListener('click', resetTimer);

      const dotButtons = ss.querySelectorAll('.slider-counter__link');
      dotButtons.forEach(btn => btn.addEventListener('click', resetTimer));
      
      // Reset timer when the slide changes (fallback and for manual swipe)
      const originalUpdate = ss.update.bind(ss);
      ss.update = function() {
        originalUpdate();
        resetTimer();
      };
    }

    animate(timestamp) {
      if (!this.lastTimestamp) {
        this.lastTimestamp = timestamp;
        requestAnimationFrame(this.animate.bind(this));
        return;
      }
      
      const deltaTime = timestamp - this.lastTimestamp;
      this.lastTimestamp = timestamp;

      if (this.slideshow.autoplayButtonIsSetToPlay) {
        this.currentTime += deltaTime;
        if (this.currentTime >= this.duration) {
          this.currentTime = 0;
          this.slideshow.autoRotateSlides();
        }
      }
      
      const progress = Math.min(this.currentTime / this.duration, 1);
      const offset = this.circumference - (progress * this.circumference);
      this.circle.style.strokeDashoffset = offset;

      requestAnimationFrame(this.animate.bind(this));
    }
  }

  customElements.whenDefined('slideshow-component').then(() => {
    document.querySelectorAll('slideshow-component').forEach(slideshow => {
      if (!slideshow.dataset.progressInitialized) {
        new SlideshowProgress(slideshow);
        slideshow.dataset.progressInitialized = 'true';
      }
    });
  });
}
